import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { UserState } from "../../../store/reducers/userReducer";
import { MenuState } from "../../../store/reducers/menuReducer";
import LcAccordion from "../../../components/Generic/LcAccordion";
import { PPDropDown, PPTextField } from "processor-plataform-ui";
import SolicitationInformationDetails from "./SolicitationInformationDetails";
import LCFlexContainer from "../../../components/Layout/LCFlexContainer";
import LCFlexItem from "../../../components/Layout/LCFlexItem";
import { SolicitationView } from "../../../models/SolicitationView";
import TabMenu from "../../../components/Generic/TabMenu";
import AttendanceDetailsComments from "./AttendanceDetailsComments";
import SolicitationSlaSlo from "./SolicitationSLASLO";
import SolicitationRequester from "./SolicitationRequester";
import SolicitationFinancial from "./SolicitationFinancial";

import ClassificationGroupService from "../../../services/ClassificationGroupService/ClassificationGroupService";
import ClassificationService from "../../../services/ClassificationService/ClassificationService";
import SolutionTypeService from "../../../services/SolutionTypeService/SolutionTypeService";
import FastSolicitationService from "../../../services/FastSolicitationService/FastSolicitationService";
import SolicitationCommentService from "../../../services/SolicitationCommentService/SolicitationCommentService";

import WorkList from "../WorkList";
import Modal from "../../../components/Dialog/Modal";
import NextAndPreviousButtons from "../../../components/Generic/NextAndPreviousButtons/NextAndPreviousButtons";
import { EndSolicitation, ReopenSolicitation } from "../../../models/FastSolicitation";
import SolicitationClassification from "./SolicitationClassification";
import LcDropDown from "../../../components/Generic/LcDropDown";
import AlertNotification, { AlertColor } from "../../../components/Dialog/AlertNotification";
import WorkService from "../../../services/WorkService/WorkService";
import LcLoading from "../../../components/Generic/LcLoading";
import LcTooltip from "../../../components/Generic/LcTooltip";
import CloseSolicitationService from "../../../services/CloseSolicitationService/CloseSolicitationService";
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import { CloseSolicitationView } from "../../../models/CloseSolicitationView";
import { LinkedSolicitations } from "./LinkedSolicitations";
import moment from "moment";
import Parse from "html-react-parser";
import "./index.css";
import { useHistory } from "react-router-dom";
import SolicitationDynamicForm from "./SolicitationDynamicForm";
import SolicitationAttendantService from "../../../services/SolicitationAttendantService/SolicitationAttendantService";
import { WorkView } from "../../../models/WorkView";
import SideModal from "../../../components/Layout/SideModal/SideModal";
import EditSubjectModal from "../../../components/Generic/EditSubjectModal";
import HHRichTextBoxDescriptionNew from "../../../components/Form/HHRichTextBoxDescriptionNew";
import SolicitationFaq from "./SolicitationFaq";
import TextTools from "../../../services/TextTools/TextTools";
import TimeKeeping from "../../../components/Generic/TimeKeeping";
import { PrefState } from "../../../store/reducers/prefReducer";
import CustomAlert from "../../../components/Dialog/CustomAlert";
import HHDescriptionTextBox from "../../../components/Form/HHDescriptionTextBox";
import { IoSparklesSharp } from "react-icons/io5";
import SolicitationConclusionSummary from "./SolicitationConclusionSummary";
import SolicitationConclusionData from "./SolicitationConclusionData";
import LcIcon from "../../../components/Generic/LcIcon";
import HHCommentAI from "../../../components/Generic/HHCommentAI";
import Lightning from "../../../assets/images/Lightning.svg";
import SvgIcon from '../../../components/Generic/SvgIcon';
import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import { PiFlagBold, PiLightning } from "react-icons/pi";
import { NewSumaryParams, setNewSummary } from "../../../components/Generic/HHContentAI/generativeIaUtils";
import { CommentNotificationState } from "../../../store/reducers/commentNotificationReducer,";

interface Props {
    nextButton: Function;
    previousButton: Function;
    solicitation: SolicitationView,
    previewSolicitation?: any;
    nextSolicitation?: any
    previewId?: string
    nextId?: string
    alterSelectedRow?: Function
    worksDone?: Function,
    disabledPreview?: boolean,
    disabledNext?: boolean,
    comments?: any[]
}

type Tipos = { value: number | string, label: string };

const SolicitationAttendantDetails: React.FC<Props> = (props) => {
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const user = useSelector<RootState, UserState>(state => state.user);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const commentNotification = useSelector<RootState, CommentNotificationState>(state => state.commentNotificationReducer);

    const dispatch = useDispatch();

    const [closeSolicitationService] = useState<CloseSolicitationService>(new CloseSolicitationService(props));
    const [workService] = useState<WorkService>(new WorkService(props));
    const [classificationGroupService] = useState<ClassificationGroupService>(new ClassificationGroupService(props));
    const [classificationService] = useState<ClassificationService>(new ClassificationService(props));
    const [solutionTypeService] = useState<SolutionTypeService>(new SolutionTypeService(props));
    const [fastSolicitationService] = useState<FastSolicitationService>(new FastSolicitationService(props));
    const [solicitationCommentService] = useState<SolicitationCommentService>(new SolicitationCommentService(props));
    const [solicitationService] = useState<SolicitationService>(new SolicitationService(props));
    const [solicitationAttendantService] = useState<SolicitationAttendantService>(new SolicitationAttendantService(props));
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const textTools = new TextTools();

    const [activeTab, setActiveTab] = useState<number>(0);
    const [status, setStatus] = useState<Tipos>({ value: "#c8c8c8", label: "" });
    const [processType, setProcessType] = useState<Tipos>({ value: 0, label: "" });
    const [urgency, setUrgency] = useState<Tipos>({ value: 0, label: "" });
    const [openNotification, setOpenNotification] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [solutionTypes, setSolutionTypes] = useState<any[]>([]);
    const [classifications, setClassifications] = useState<any[]>([]);
    const [classificationsGroup, setClassificationsGroup] = useState<any[]>([]);
    const [allWorksCompleted, setAllWorksCompleted] = useState<boolean>(false);
    const [solicitation, setSolicitation] = useState<any>();
    const [loadingConfirmEnd, setLoadingConfirmEnd] = useState<boolean>(false);
    const [loadingReopen, setLoadingReopen] = useState<boolean>(false);
    const [lastWorkCompleted, setLastWorkCompleted] = useState<any>();
    const [solutionText, setSolutionText] = useState<string>("");
    const [classificationText, setClassificationText] = useState<string>("");
    const [classificationGroupText, setClassificationGroupText] = useState<string>("");
    const [solutionTypeText, setSolutionTypeText] = useState<string>("");
    const history = useHistory();
    const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);
    const [worksToAprove, setWorksToAprove] = useState<boolean>(false);
    const [disableButton, setDisableButton] = useState<boolean>(true);
    const [confirmReopen, setConfirmReopen] = useState(false);
    const [confirmEnd, setConfirmEnd] = useState(false);
    const [confirmClose, setConfirmClose] = useState(false);
    const [linkedLenght, setLinkedLenght] = useState<number>(0);
    const [openConclusionSummary, setOpenConclusionSummary] = useState<boolean>(false);
    const [reloadSummaryConclusion, setReloadSummaryConclusion] = useState<boolean>(false);
    const [loadingConfirmClose, setLoadingConfirmClose] = useState<boolean>(false);
    const [reloadComments, setReloadComments] = useState<boolean>(false);
    const [reloadWorks, setReloadWorks] = useState<boolean>(false);
    const [enableCompleted, setEnableCompleted] = useState<boolean>(false);
    const [loadingSaveSubject, setLoadingSaveSubject] = useState<boolean>(false);
    const [modalConfirmCloseVisible, setModalConfirmCloseVisible] = useState<boolean>(false);
    const [sugestaoExp, setSugestaoExp] = useState<boolean>(false);
    const [commentSummaryVisible, setCommentSummaryVisible] = useState<boolean>(false);
    const [showToolBar, setShowToolBar] = useState<boolean>(false);
    const [activeAi, setActiveAi] = useState<any>();
    // const [text, setText] = useState('');

    const [formEndSolicitation, setFormEndSolicitation] = useState({
        closed: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        solutiontype: 0,
        classificationgroup: 0,
        classification: 0
    });

    useEffect(() => {
        dispatch({ type: 'PREF_PROMPT_STATUS', payload: false });
        setAllWorksCompleted(false);
        setEnableCompleted(false);

        const params = new URLSearchParams(new URL(window.location.href).search);
        const activeTab = params.get('activeTab');

        if (activeTab) {
            setActiveTab(parseInt(activeTab));
        }

        if (props.solicitation) {
            // setActiveTab(0);
            setSolicitation(props.solicitation);
        }

        onClose();
    }, []);

    useEffect(() => {
        if (solicitation) {
            init();
            CheckAiConfig();

            if (solicitation.idStatus === 6 || solicitation.idStatus === 8 || solicitation.idStatus === 7) {
                dispatch({ type: 'PREF_PROMPT_STATUS', payload: false });
            }
        }
    }, [solicitation]);

    const CheckAiConfig = async () => {
        try {
            const response = await generativeIaEvaluationService.CheckAiConfig(props.solicitation.id);
            setActiveAi(response.data);
        }
        catch (error) {
            console.error(error);
        }
    }

    const init = async () => {
        setLoadingConfirmEnd(false);
        setLastWorkCompleted(undefined);

        let status = solicitationService.statusList.find(x => solicitation && x.value === solicitation.idStatus.toString());
        if (status) setStatus({ value: status.value, label: status.label });

        let processType = solicitationService.processTypeList.find(x => solicitation && x.value === solicitation.processType);
        if (processType) setProcessType(processType);

        let urgency = solicitationService.urgency.find(x => x.id === solicitation.urgency);
        if (urgency) setUrgency({ value: urgency.id, label: urgency.label });

        // setSolutionTypes([]);
        // setClassificationsGroup([]);
        // setClassifications([]);

        setFormEndSolicitation({
            closed: solicitation.endDate ? moment(solicitation.endDate).format("YYYY-MM-DDTHH:mm") : moment(new Date()).format("YYYY-MM-DDTHH:mm"),
            solutiontype: (solicitation.idSolutionType || 0),
            classificationgroup: (solicitation.idClassificationGroup || 0),
            classification: (solicitation.idClassification || 0)
        });

        try {
            const resp = await solutionTypeService.getSolutionTypes(solicitation.idBusinessArea);
            setSolutionTypes(mountDropList(resp.data));
            const solType = resp.data.find((s: { id: number; }) => s.id === solicitation.idSolutionType)?.description;
            setSolutionTypeText((solType) ? solType : resp.data[0].description);
        }
        catch (error) {
            console.warn(error);
        }

        try {
            const resp = await classificationGroupService.getClassificationGroupByService(solicitation.idService);
            setClassificationsGroup(mountDropList(resp.data));

            const grupoClassification = resp.data.find(s => s.id === solicitation.idClassificationGroup)?.description;
            setClassificationGroupText((grupoClassification) ? grupoClassification : resp.data[0].description);
            solicitation.idClassification !== 0 && getClassification(solicitation.idClassificationGroup);
        }
        catch (error) {
            console.warn(error);
        }
    }

    const getClassification = async (idClassificationGroup: number) => {
        try {
            // const idClassificationGroup_ = (solicitation.idClassificationGroup !== 0 && solicitation.idClassificationGroup !== null)
            //     ? solicitation.idClassificationGroup
            //     : id;

            const resp = await classificationService.getClassificationByService(solicitation.idService, idClassificationGroup);
            setClassifications(mountDropList(resp.data));

            const classification = resp.data.find(s => s.id === solicitation.idClassification)?.description;
            resp.data.sort((a, b) => { return a.description > b.description ? 1 : -1 })

            setClassificationText((classification) ? classification : (resp.data[0]?.description) ? resp.data[0].description : "");
        }
        catch (error) {
            console.warn(error);
        }
    }

    // const checkWorksEnd = async (id: number) => {
    //     try {
    //         const resp = await workService.getWorkViewbySolicitation(id)

    //         let status = resp.filter((x: WorkView) => x.idStatus !== 6 && x.idStatus !== 7);

    //         if (status.length !== 0) {
    //             setConfirmClose(false);
    //             setWorksDone(false)
    //             props.worksDone && props.worksDone(false);
    //         }
    //         else {
    //             props.worksDone && props.worksDone(true);
    //             setConfirmClose(true);
    //             setWorksDone(true)
    //         }
    //     }
    //     catch (error) {
    //         console.error(error)
    //     }
    // }

    useEffect(() => {
        if (lastWorkCompleted) {
            setSolutionText(lastWorkCompleted.workRealized);

            if (solicitation) {
                if (solicitation.idStatus !== 6 && solicitation.idStatus !== 8 && solicitation.idStatus !== 7) {
                    dispatch({ type: 'PREF_PROMPT_STATUS', payload: allWorksCompleted });
                }
                else {
                    dispatch({ type: 'PREF_PROMPT_STATUS', payload: false });
                }
            }
        }
    }, [lastWorkCompleted])

    const mountDropList = (list: any[]) => {
        let result = [];

        if (list.length > 0) {
            let _list = list.filter(c => c.disabled === 0 || c.disabled === false)
                .map(c => { return { label: c.description || c.name, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 });

            return [...result, ..._list];
        }
        else {
            return result;
        }
    }

    const handleSubmitEnd = async (event: any, openConclusionSummary?: boolean) => {
        event.preventDefault();

        if (formEndSolicitation.solutiontype === 0) {
            notificationWarningValidation("Preencha um tipo de solução válido");
        }
        else if (formEndSolicitation.classificationgroup === 0) {
            notificationWarningValidation("Preencha um grupo de classificação válido");
        }
        else if (formEndSolicitation.classification === 0) {
            notificationWarningValidation("Preencha uma classificação válida");
        }
        else {
            setLoadingConfirmClose(true);
            dispatch({ type: 'PREF_PROMPT_STATUS', payload: false });

            let CloseSolicitationViewData: CloseSolicitationView = {
                id: solicitation.id,
                idSolutionType: formEndSolicitation.solutiontype,
                idClassification: formEndSolicitation.classification,
                idCause: 1,
                conclusionText: solutionText,
                IdUser: Number(user.id),
                closingDateTime: formEndSolicitation.closed
            };

            try {
                await closeSolicitationService.closeSolicitation(CloseSolicitationViewData);
            }
            catch (error) {
                console.warn(error);
            }

            await getUpdatedSolicitation();

            setLoadingConfirmClose(false);
            handleConfirmCloseModal();
            // setReloadSummaryConclusion(true);

        }
    }

    const getUpdatedSolicitation = async () => {
        try {
            const solicitationResponse = await solicitationService.getSolicitationDetailById(solicitation.id);
            setSolicitation(solicitationResponse.data);
            props.alterSelectedRow && props.alterSelectedRow(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error)
        }
    }

    const handleSubmitReopen = async (event: any) => {
        event.preventDefault();

        setLoadingReopen(true);

        let data: ReopenSolicitation = {
            comment: event.target["comment"].value,
            solicitationId: solicitation.id,
        }

        try {
            await fastSolicitationService.reopenSolicitation(data);
        }
        catch (error) {
            console.warn(error);
        }

        await getUpdatedSolicitation();
        setConfirmReopen(false);
        setAllWorksCompleted(false);
        window.location.reload();
        setLoadingReopen(false);
    }

    const notificationWarningValidation = (mensagem: string) => {
        setMessage(mensagem);
        setSeverity("warning");
        setOpenNotification(true);
    }

    const handleCloseNotification = () => {
        setOpenNotification(false);
    }

    const handleConfirmCloseModal = () => {
        setOpenNotification(false);
        setMessage("");
        setConfirmClose(false);
        if (lastWorkCompleted) setSolutionText(lastWorkCompleted.workRealized);
    }

    useEffect(() => {
        if (enableCompleted && !pref.openedModalWork) {
            setConfirmClose(true);
        }
    }, [enableCompleted])

    const handleRefreshData = (workList: any[], type: string) => {
        // setReloadComments(true);
        const listWorksCompleted = workList.filter(work => work.idStatus === 6 || work.idStatus === 7 || work.idStatus === 8);

        if (type === "works") {
            if (workList.length > 0 && workList.length === listWorksCompleted.length) {
                setAllWorksCompleted(true);
            }
            else {
                setAllWorksCompleted(false);
            }
        }
    }

    useEffect(() => {
        setEnableCompleted(allWorksCompleted);
        if (solicitation && (solicitation.idStatus !== 6 && solicitation.idStatus !== 8 && solicitation.idStatus !== 7))
            dispatch({ type: 'PREF_PROMPT_STATUS', payload: allWorksCompleted });
    }, [allWorksCompleted])

    const handleSubmitClose = async () => {
        setLoadingConfirmEnd(true);
        let endSolicitation: EndSolicitation = { solicitationId: solicitation.id };

        try {
            await fastSolicitationService.endSolicitation(endSolicitation);
            await getUpdatedSolicitation();
            setMessage("Chamado encerrado com sucesso!")
            setSeverity("success")
        }
        catch (error) {
            console.error(error);
            setMessage(`Ocorreu um erro ao encerrar chamado`);
            setSeverity("error");
        }

        setOpenNotification(true)
        setLoadingConfirmEnd(false);
        setReloadSummaryConclusion(commentNotification[props.solicitation.id].sumarization);
        setConfirmEnd(false);
    }

    const onChangeSolutionType = (event: any) => {
        setFormEndSolicitation({
            ...formEndSolicitation,
            solutiontype: event.target.value
        });

        setSolutionTypeText(solutionTypes.find(s => s.value === event.target.value.toString())?.label);
    }

    const onChangeClassificationGroup = async (event: any) => {
        // setClassifications([]);
        setFormEndSolicitation({
            ...formEndSolicitation,
            classificationgroup: event.target.value
        });

        setClassificationGroupText(classificationsGroup.find(s => s.value === event.target.value.toString())?.label);

        try {
            const classificationResponse = await classificationService.getClassificationByService(solicitation.idService, event.target.value);
            setClassifications(mountDropList(classificationResponse.data));
        }
        catch (error) {
            console.warn(error);
        }
    }

    const onChangeClassification = (event: any) => {
        setFormEndSolicitation({
            ...formEndSolicitation,
            classification: event.target.value
        });
        setClassificationText(classifications.find(s => s.value === event.target.value)?.label);
    }

    const onChangeDate = (event: any) => {
        setFormEndSolicitation({
            ...formEndSolicitation,
            closed: event.target.value
        });
    }

    useEffect(() => {
        if (solutionTypes.length > 0 || classificationsGroup.length > 0 || classifications.length > 0) {
            let formEndSolicitation_ = formEndSolicitation;

            if (solutionTypes.length === 1) {
                formEndSolicitation_ = { ...formEndSolicitation_, solutiontype: solutionTypes[0].value };
            }

            if (classificationsGroup.length === 1) {
                formEndSolicitation_ = { ...formEndSolicitation_, classificationgroup: classificationsGroup[0].value };
            }

            if (classifications.length === 1) {
                formEndSolicitation_ = { ...formEndSolicitation_, classification: classifications[0].value };
            }

            if (formEndSolicitation !== formEndSolicitation_) {
                setFormEndSolicitation(formEndSolicitation_);
            }
        }
    }, [solutionTypes, classificationsGroup, classifications])

    const [updateClassification, setUpdateClassification] = useState<boolean>(false);

    useEffect(() => {
        if (updateClassification) {
            getUpdatedSolicitation();
            setUpdateClassification(false);
            setReloadComments(true);
            setReloadWorks(true);
        }
    }, [updateClassification])

    const alterLoadingSaveSubject = (value: boolean) => {
        setLoadingSaveSubject(value);
    }

    const alterSelectedRow = (row: any) => {
        setSolicitation(row);
    }

    const handleClose = () => {
        if (enableCompleted && (solicitation.idStatus !== 6 && solicitation.idStatus !== 8 && solicitation.idStatus !== 7)) {
            setModalConfirmCloseVisible(true);
            return;
        }

        closeModal();
    }

    const closeModal = () => {
        setSolicitation(undefined);
        history.push(pref.promptPath ? pref.promptPath : "/Attendance");
        dispatch({ type: 'PREF_PROMPT_STATUS', payload: false });
        onClose();
    }

    useEffect(() => {
        if (formEndSolicitation.classification.toString() !== "0" &&
            formEndSolicitation.classificationgroup.toString() !== "0" &&
            formEndSolicitation.closed !== "0" &&
            formEndSolicitation.solutiontype.toString() !== "0" &&
            solutionText !== ""
        ) {
            setDisableButton(false);
        }
        else {
            setDisableButton(true);
        }
    }, [formEndSolicitation, solutionText]);

    useEffect(() => {
        if (formEndSolicitation.classificationgroup !== 0) {
            getClassification(formEndSolicitation.classificationgroup);
        }
    }, [formEndSolicitation.classificationgroup]);

    const onClose = () => {
        setModalConfirmCloseVisible(false)
        dispatch({ type: 'PREF_PROMPT_SHOW', payload: false });
        dispatch({ type: 'PREF_PROMPT_PATH', payload: null });
    }

    useEffect(() => {
        if (showToolBar === false) {
            setSugestaoExp(false);
        }
    }, [showToolBar]);

    const handleSubmitEndSumarization = async (e, sumarizar: boolean) =>{
        await handleSubmitEnd(e)
        let solicitationParams: NewSumaryParams = {
            solicitationId: props.solicitation.id,
            IdUser: user.id || 0,
            recordType: 1,
            numberOfComments: commentNotification[props.solicitation.id].numberOfComments,
            conclusionText: solutionText,
            summary: sumarizar
        }
        setLoadingSaveSubject(true)
        setTimeout(async () => {
            try {
                if (user.id) {
                    const response: any = await setNewSummary(solicitationParams, dispatch, props);
                    if (response?.status === 200  ) {
                        setReloadSummaryConclusion(sumarizar)
                        setActiveTab(4);
                    }
                }
            } catch (error) {
                console.error("Error setting new summary:", error);
            } finally {
                setLoadingSaveSubject(false);
            }
        },3000)
    }

    const conclusionOpts = [
        {
            icon: <PiFlagBold width={15} height={15}/>,
            text: 'Concluir',
            function: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => handleSubmitEndSumarization(e, false)
        },
        {
            icon:  <SvgIcon icon={Lightning}  width={15} height={15}  />,
            text: 'Concluir e sumarizar',
            function: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => handleSubmitEndSumarization(e, true)
        },
    ]


    return (
        <SideModal
            header={
                <EditSubjectModal
                    selectedRow={solicitation}
                    alterLoadingSaveSubject={alterLoadingSaveSubject}
                    loadingSaveSubject={loadingSaveSubject}
                    alterSelectedRow={alterSelectedRow}
                    activeAi={activeAi}
                    comments={props.comments}
                />
            }
            width={`calc(100% - ${(menu.toggle) ? "80px" : "260px"})`}
            visible={props.solicitation !== undefined}
            onClose={() => handleClose()}
            backgroundColor={"#FAFAFA"}
        >
            <LcLoading loading={loadingSaveSubject} label="Carregando...">
                <CustomAlert
                    visible={modalConfirmCloseVisible || (pref.promptShow ? pref.promptShow : false)}
                    title={"Fechar janela?"}
                    message={"Os trabalhos estão concluídos, mas o chamado permanece aberto."}
                    onClose={() => onClose()}
                    onClick={() => closeModal()}
                />

                <AlertNotification open={openNotification} severity={severity} message={message} handleClose={handleCloseNotification} minHeight={""} />
                {/* <SolicitationConclusionSummary
                    visible={openConclusionSummary}
                    setVisible={setOpenConclusionSummary}
                    solicitation={solicitation}
                    user={user}
                    conclusionText={solutionText}
                    setReloadSummaryConclusion={setReloadSummaryConclusion}
                /> */}
                {
                    solicitation &&
                    <>
                        <TabMenu items={[
                            { label: "Informações", onClick: () => { setActiveTab(0); }, active: activeTab === 0 },
                            { label: "Comentários", onClick: () => { setActiveTab(1); }, active: activeTab === 1 },
                            { label: "Trabalhos", onClick: () => { setActiveTab(2); }, active: activeTab === 2, alertball: worksToAprove },
                            { label: `Vinculados (${linkedLenght})`, onClick: () => { setActiveTab(3); }, active: activeTab === 3, hidden: solicitation.idLinkedSolicitation === 0 || solicitation.processType !== 9 },
                            { label: "Conclusão", onClick: () => { setActiveTab(4); }, active: activeTab === 4, hidden: solicitation && !(solicitation.idStatus === 6 || solicitation.idStatus === 7 || solicitation.idStatus === 8) },
                            { label: "Formulário", onClick: () => { setActiveTab(5); }, active: activeTab === 5, hidden: !solicitation.hasForm },
                        ]}>
                            {
                                solicitation && !(solicitation.idStatus === 6 || solicitation.idStatus === 7 || solicitation.idStatus === 8)
                                    ? <>
                                        <LcTooltip
                                            trigger={(!enableCompleted) ? "hover" : undefined}
                                            content={<span><b>Impedimento</b> Todos os trabalhos devem estar concluídos para realizar a conclusão do chamado!</span>}
                                            position={"left"}
                                        >
                                            <div
                                                style={{
                                                    height: "36px",
                                                    width: "90px",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    flexWrap: "wrap",
                                                    alignContent: "center",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <button
                                                    className="lc-button small"
                                                    onClick={() => setConfirmClose(true)}
                                                    disabled={!enableCompleted}
                                                    style={{
                                                        cursor: (enableCompleted) ? "pointer" : "default",
                                                        backgroundColor: (enableCompleted) ? "#ffb800" : "#fafafa",
                                                        border: (enableCompleted) ? "none" : "1px solid dimgray",
                                                    }}
                                                    children={"Concluir"}
                                                />
                                            </div>
                                        </LcTooltip>


                                        <Modal
                                            visible={confirmClose}
                                            title={"Concluir chamado"}
                                            close={() => handleConfirmCloseModal()}
                                            width={(loadingConfirmClose) ? "600px" : "900px"}
                                        >
                                            <form className={"form"}>
                                                <LcLoading label={"Carregando..."} loading={loadingConfirmClose}>
                                                    <div
                                                        className={"rowConcluir"}
                                                        style={{
                                                            display: "flex",
                                                            width: "100%"
                                                        }}>
                                                        <div className={"input-7"}>
                                                            <PPTextField
                                                                name={"closed"}
                                                                type={"datetime-local"}
                                                                label={"Data da conclusão"}
                                                                value={formEndSolicitation.closed}
                                                                onChange={onChangeDate}
                                                                readOnly={(user.adjustedWorkingTime || user.allowChangeTime) ? false : true}
                                                            />
                                                        </div>

                                                        <div className="input-6">
                                                            <PPDropDown
                                                                name="solutiontype"
                                                                required
                                                                title="Tipo de solução"
                                                                options={solutionTypes}
                                                                value={(formEndSolicitation.solutiontype) ? formEndSolicitation.solutiontype : 0}
                                                                onChange={onChangeSolutionType}
                                                                placeholder={"Tipo de solução"}
                                                                placeholderSearch={"Buscar tipo de solução"}
                                                            />
                                                        </div>

                                                        <div className="input-6">
                                                            <PPDropDown
                                                                name="classificationgroup"
                                                                required
                                                                title="Grupo de classificação"
                                                                options={classificationsGroup}
                                                                value={(formEndSolicitation.classificationgroup) ? formEndSolicitation.classificationgroup : 0}
                                                                onChange={onChangeClassificationGroup}
                                                                placeholder={"Grupo de classificação"}
                                                                placeholderSearch={"Buscar grupo de classificação"}
                                                            />
                                                        </div>

                                                        <div className="input-6">
                                                            <PPDropDown
                                                                name="classification"
                                                                required
                                                                title="Classificação"
                                                                options={classifications}
                                                                value={(formEndSolicitation.classification) ? formEndSolicitation.classification : 0}
                                                                onChange={onChangeClassification}
                                                                placeholder={"Classificação"}
                                                                placeholderSearch={"Buscar classificação"}
                                                                disabled={classifications.length === 0}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="input-12" style={{ width: "100%" }}>
                                                        {/* <div className={"input-4 label labelSolutionTextConclusionButton"}> Solução </div> */}
                                                        {/* <HHRichTextBoxDescriptionNew handleChange={(e) => setSolutionText(e)} value={solutionText} /> */}
                                                        <HHDescriptionTextBox
                                                            label="Solução"
                                                            height={"150px"}
                                                            required={true}
                                                            handleChange={(e) => setSolutionText(e)}
                                                            value={solutionText}
                                                            solicitation={solicitation}
                                                            suggestion={activeAi && activeAi.configSuggestion}
                                                            suggestionStyleItem={{
                                                                position: "relative",
                                                                left: "95%",
                                                                top: "10px",
                                                                zIndex: "9",
                                                                background: "white",
                                                                width: "40px",
                                                                borderRadius: "40px"
                                                            }}
                                                        />
                                                    </div>
                                                    <div className={"row space-between"}>
                                                    
                                                        {
                                                            activeAi && activeAi.configSummary ?
                                                            <LcDropDown
                                                                trigger="click"
                                                                disabled={disableButton}
                                                                class="concluir"
                                                                position="Left"
                                                                element={
                                                                    <button type="button" disabled={disableButton} className={"lc-button bg-info"}>Concluir  <i className={"ppi ppi-chevron-down-alt"} /></button>
                                                                    }>
                                                                <>
                                                                {
                                                                    conclusionOpts.map((opts, index) => {
                                                                            return(
                                                                                <div key={index} className="row item" style={{display: 'flex', gap: '0px'}} onClick={(e) => opts.function(e)}>
                                                                                    {opts.icon}
                                                                                    <span style={{fontSize: '12px'}}>{opts.text}</span>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </>                                                     
                                                            </LcDropDown>
                                                            :
                                                            <button disabled={disableButton} className={"lc-button bg-info"} onClick={(e) => handleSubmitEnd(e)}>Concluir</button>
                                                        }
                                                        
                                                        <button type={"reset"} className={"lc-button bg-info-alt"} onClick={() => { handleConfirmCloseModal() }}>Cancelar</button>
                                                    </div>
                                                </LcLoading>
                                            </form>

                                            <AlertNotification
                                                open={openNotification}
                                                severity={severity}
                                                message={message}
                                                handleClose={handleCloseNotification}
                                                minHeight={""}
                                            />
                                        </Modal>
                                    </>
                                    : <>
                                        {
                                            solicitation && solicitation.idStatus === 7 &&
                                            <LcDropDown class="encerrar" position="Left" element={<button className={"lc-button small bg-info"}> Encerrar <i className={"ppi ppi-chevron-down-alt"} /> </button>}>
                                                <button className={"lc-button bg-info"} style={{ marginBottom: "5px",width: '100%'}} onClick={() => setConfirmEnd(true)}> Encerrar </button>
                                                <button className={"lc-button bg-info-alt"} style={{width: '100%'}} onClick={() => setConfirmReopen(true)}> Reabrir </button>
                                            </LcDropDown>
                                        }

                                        <Modal visible={confirmReopen} title={"Reabrir chamado"} close={() => setConfirmReopen(false)}>
                                            <form className="form" onSubmit={handleSubmitReopen}>
                                                <LcLoading label="Carregando..." loading={loadingReopen}>
                                                    <div className="input-12">
                                                        <PPTextField name="comment" multiline label="Motivo" />
                                                    </div>

                                                    <div className="commands">
                                                        <button type="submit" className="lc-button bg-info"> Reabrir </button>
                                                        <button type="reset" className="lc-button bg-info-alt" onClick={() => setConfirmReopen(false)}> Cancelar </button>
                                                    </div>
                                                </LcLoading>
                                            </form>
                                        </Modal>

                                        <Modal visible={confirmEnd} title="Encerrar chamado" close={() => { setConfirmEnd(false) }} >
                                            <div className="form">
                                                <LcLoading label={"Carregando..."} loading={loadingConfirmEnd}>
                                                    <p> Confirma o encerramento do chamado? </p>
                                                    <div className={"commands"}>
                                                        <button
                                                            // type="button"
                                                            className={"lc-button bg-info"}
                                                            onClick={() => handleSubmitClose()}
                                                        >Encerrar</button>
                                                        <button
                                                            type={"reset"}
                                                            className={"lc-button bg-info-alt"}
                                                            onClick={() => setConfirmEnd(false)}
                                                        >Cancelar</button>
                                                    </div>
                                                </LcLoading>
                                            </div>
                                        </Modal>
                                    </>
                            }

                            {/* <SolicitationConclusion
                                user={user}
                                solicitation={solicitation}
                                getUpdatedSolicitation={getUpdatedSolicitation}
                                allWorksCompleted={allWorksCompleted}
                                lastWorkCompleted={lastWorkCompleted}
                                setSolutionText={setSolutionText}
                                setClassificationText={setClassificationText}
                                setClassificationGroupText={setClassificationGroupText}
                                setEnableCompleted={setEnableCompleted}
                            /> */}

                            {
                                (() => {
                                    if ((props.previewSolicitation || props.nextSolicitation) && (props.previewSolicitation != 0 && props.nextSolicitation != 0)) {
                                        return (
                                            <NextAndPreviousButtons
                                                onClickNext={() => props.nextButton()}
                                                onClickPrevious={() => props.previousButton()}
                                                nextSolicitation={props.nextSolicitation}
                                                previewSolicitation={props.previewSolicitation}
                                                disabledNext={props.disabledNext}
                                                disabledPrevious={props.disabledPreview}
                                                nextTooltipPosition={"fullLeft"}
                                            />
                                        )
                                    }
                                })()
                            }

                        </TabMenu>

                        <div style={{ display: "flex", gap: "20px" }} className={(activeTab === 0) ? "" : "hide"}>
                            <div className={"solicitationsInfos"}>
                                {
                                    solicitation &&
                                    <SolicitationInformationDetails solicitation={solicitation} />
                                }
                                {
                                    solicitation &&
                                    <SolicitationRequester
                                        solicitation={solicitation}
                                        onSubmit={() => setUpdateClassification(true)}
                                        activeTab={activeTab}
                                    />
                                }
                                {
                                    solicitation &&
                                    <SolicitationFaq solicitation={solicitation} />
                                }
                            </div>
                            <div className={"solicitationsInfos"}>
                                {
                                    solicitation &&
                                    <SolicitationSlaSlo solicitation={solicitation} />
                                }
                                {
                                    solicitation && solicitation.timeKeep &&
                                    <LCFlexItem>
                                        <div className={"timeKeep"}>
                                            <TimeKeeping editable={false} solicitation={solicitation} />
                                        </div>
                                    </LCFlexItem>
                                }
                                <LcAccordion title={"Classificação"} visible={true} iconNormal>
                                    {
                                        solicitation &&
                                        <SolicitationClassification
                                            user={user}
                                            solicitation={solicitation}
                                            submitClassification={() => setUpdateClassification(true)}
                                        />
                                    }
                                </LcAccordion>
                                {
                                    solicitation &&
                                    <SolicitationFinancial solicitation={solicitation} />
                                }
                            </div>
                        </div>

                        <div className={(activeTab === 1) ? "" : "hide"} >
                            <LCFlexContainer spacing={2}>
                                <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                    {
                                        solicitation &&
                                        <AttendanceDetailsComments
                                            row={solicitation}
                                            tab={activeTab}
                                            reloadComments={reloadComments}
                                            changeReloadComments={() => setReloadComments(false)}
                                        />
                                    }
                                </LCFlexItem>
                            </LCFlexContainer>
                        </div>

                        <div className={(activeTab === 2) ? "" : "hide"} >
                            <LCFlexContainer spacing={2}>
                                <LCFlexItem xs={12} sm={12} md={12} lg={12}>
                                    {
                                        solicitation &&
                                        <WorkList
                                            solicitation={solicitation}
                                            handleRefreshData={handleRefreshData}
                                            setLastWorkCompleted={(e) => setLastWorkCompleted(e)}
                                            getUpdatedSolicitation={getUpdatedSolicitation}
                                            aproverworks={setWorksToAprove}
                                            reloadWorks={reloadWorks}
                                            changeReloadWorks={() => setReloadWorks(false)}
                                        />
                                    }
                                </LCFlexItem>
                            </LCFlexContainer>
                        </div>

                        <div className={(activeTab === 3) ? "" : "hide"} >
                            {
                                solicitation && (solicitation.idLinkedSolicitation !== null || solicitation.processType === 9) &&
                                <LinkedSolicitations
                                    handleLength={setLinkedLenght}
                                    solicitation={solicitation}
                                    handleRefreshData={handleRefreshData}
                                />
                            }
                        </div>

                        {/* <div className={`form${(activeTab === 4) ? "" : " hide"}`} >
                            <SolicitationConclusionData
                                formEndSolicitation={formEndSolicitation}
                                solutionTypeText={solutionTypeText}
                                classificationGroupText={classificationGroupText}
                                classificationText={classificationText}
                                solicitation={solicitation}
                            />
                        </div> */}
                        <div className={`form${(activeTab === 4) ? "" : " hide"}`} >
                            <SolicitationConclusionData
                                formEndSolicitation={formEndSolicitation}
                                solutionText={solutionText}
                                solutionTypeText={solutionTypeText}
                                classificationGroupText={classificationGroupText}
                                classificationText={classificationText}
                                solicitation={solicitation}
                                activeTab={activeTab}
                                reloadSummaryConclusion={reloadSummaryConclusion}
                                user={user}
                            />

                        </div>

                        <div className={(activeTab === 5) ? "" : "hide"}>
                            {
                                solicitation && solicitation.hasForm &&
                                <SolicitationDynamicForm visible={activeTab === 5} solicitation={solicitation} />
                            }
                        </div>
                    </>
                }
            </LcLoading>
        </SideModal>
    );
};

export default SolicitationAttendantDetails;